import api from '../../api';
import output from '../../../utils/output-writer';
import { WrappedRegisterToolFuncType } from '../tool-definition';
import { createCallToolResult, createTextContent } from '../output-parser';

export function setup(register: WrappedRegisterToolFuncType) {
  register(
    'list-playbooks',
    {
      title: 'List Playbooks',
      description:
        'List all available playbooks, including their monitor names and required attributes. Currently only returns playbooks visible to all users.',
    },
    async () => {
      output.info('Listing playbooks');

      const result = await api.listPlaybooks();

      return createCallToolResult({
        contentBlocks: [createTextContent(JSON.stringify(result, null, 2))],
      });
    }
  );
}

export default { setup };
